import { useUser } from "@clerk/clerk-react";
import { useEffect, useState, useCallback } from "react";
import { supabase } from "../lib/supabase";

export function useLetterCount() {
  const { user } = useUser();
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchCount = useCallback(async () => {
    if (!user) return;
    const startOfMonth = new Date();
    startOfMonth.setDate(1);
    startOfMonth.setHours(0, 0, 0, 0);

    const { count: c } = await supabase
      .from("letter_generations")
      .select("*", { count: "exact", head: true })
      .eq("clerk_user_id", user.id)
      .gte("created_at", startOfMonth.toISOString());

    setCount(c ?? 0);
    setLoading(false);
  }, [user?.id]);

  useEffect(() => {
    fetchCount();
  }, [fetchCount]);

  return { count, loading, refetch: fetchCount };
}